import RegisterContainer from "../../Register/RegisterContainer";
import classNames from "classnames/bind";
import styles from './VerifyForgotPassword.module.css';
import RegisterVerifyContainer from "../../Register/RegisterVerifyContainer";
import { Toast } from "../../../components";
// eslint-disable-next-line
const cx = classNames.bind(styles)

function VerifyForgotPassword() {
    const getError = (data) => {
        if (data) {
            Toast.open(data, 'danger')
        }
    }
    return (
        <>
            <div id="__notification"></div>
            <RegisterContainer verify>
                <RegisterVerifyContainer header={'Mã xác thực tài khoản'} back={'/forgot-password'} forgotPass getError={getError} />
            </RegisterContainer>
        </>
    )
}

export default VerifyForgotPassword